import { getBookingsRelativeUrl, queryBuilder, getUrlQueryParams, getSectionRelativeUrl, BOOKINGS_CALENDAR_SECTION_ID, isBookingsSectionInstalled } from '@wix/bookings-catalog-calendar-viewer-utils';
import { LocationType } from '@wix/ambassador-bookings-services-v2-service/types';
async function getBookingCalendarRelativeUrl(wixCodeApi) {
  if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) {
    return getSectionRelativeUrl(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID);
  }
  return getBookingsRelativeUrl(wixCodeApi);
}
async function navigateToBookingsCalendarPageWithBasket(wixCodeApi, basket, navigationContext) {
  if (navigationContext === void 0) {
    navigationContext = {};
  }
  const location = basket.location.type === LocationType.BUSINESS ? basket.location.value : undefined;
  const calendarSelections = {
    location,
    services: basket.selectedServicesPreferences.map(preferences => ({
      id: preferences.service.id,
      resources: Object.values(preferences.resources)[0],
      variants: preferences.variant && !preferences.variant.choices[0].staffMemberId ? [{
        choices: [{
          optionId: preferences.variant.choices[0].optionId,
          custom: preferences.variant.choices[0].custom
        }]
      }] : undefined
    }))
  };
  return navigateToBookingsBookAction(wixCodeApi, {
    referral: navigationContext.referral,
    timezone: navigationContext.timezone,
    selections: encodeURIComponent(JSON.stringify(calendarSelections)),
    copyCurrentQueryParams: false
  });
}
async function getUrlSuffix(wixCodeApi, serviceSlug) {
  return (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) ? "/" + serviceSlug : "/" + serviceSlug + "/book";
}
async function navigateToBookingsBookAction(wixCodeApi, _temp) {
  var _copyCurrentQueryPara;
  let {
    serviceSlug,
    referral,
    staff,
    location,
    timezone,
    selections,
    resource,
    copyCurrentQueryParams
  } = _temp === void 0 ? {} : _temp;
  copyCurrentQueryParams = (_copyCurrentQueryPara = copyCurrentQueryParams) != null ? _copyCurrentQueryPara : true;
  const suffix = serviceSlug ? await getUrlSuffix(wixCodeApi, serviceSlug) : '';
  const query = queryBuilder({
    ...(copyCurrentQueryParams ? getUrlQueryParams(wixCodeApi) : {}),
    ...(serviceSlug ? {
      staff,
      timezone,
      location
    } : {
      selections
    }),
    referral,
    resource
  });
  const bookingCalendarRelativeUrl = await getBookingCalendarRelativeUrl(wixCodeApi);
  wixCodeApi.location.to("" + bookingCalendarRelativeUrl + (suffix + query));
}
export async function navigateToBookingsCalendarPage(wixCodeApi, _ref) {
  let {
    serviceSlugOrBasket,
    navigationContext = {}
  } = _ref;
  if (typeof serviceSlugOrBasket === 'string' || serviceSlugOrBasket instanceof String) {
    return navigateToBookingsBookAction(wixCodeApi, {
      ...navigationContext,
      serviceSlug: serviceSlugOrBasket
    });
  } else {
    return navigateToBookingsCalendarPageWithBasket(wixCodeApi, serviceSlugOrBasket, navigationContext);
  }
}
//# sourceMappingURL=navigateToBookingsCalendarPage.js.map